export default __webpack_public_path__ + "static/media/2-min.c81cef73.jpg";